import { createSlice } from '@reduxjs/toolkit';
import FJImageExtenderData from '../../config/dataConfig/FJImageExtenderData';

export const FJSliceImageExtender = createSlice({
    name: 'imageExtender',
    initialState: {
        uploadImageInfo: {},
        curRatioName: 'original',

        boardSize: {
            width: 0,
            height: 0,
        },

        imageRect: {
            width: 0,
            height: 0,
            x: 0,
            y: 0,
        },

        generateNumber: FJImageExtenderData.IMAGE_NUMBER_LIST[0].value,
    },
    reducers: {
        setSliceUploadImageInfo: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSliceCurRatioName: (state, action) => {
            state.curRatioName = action.payload;
        },
        setSliceBoardSize: (state, action) => {
            state.boardSize = action.payload;
        },
        setSliceImageRect: (state, action) => {
            state.imageRect = action.payload;
        },
        setSliceGenerateNumber: (state, action) => {
            state.generateNumber = action.payload;
        },
    },
});

export const {
    setSliceUploadImageInfo,
    setSliceCurRatioName,
    setSliceBoardSize,
    setSliceImageRect,
    setSliceGenerateNumber,
} = FJSliceImageExtender.actions;

export default FJSliceImageExtender.reducer;
